module.exports = __webpack_public_path__ + "static/media/174-denmark.6faa90be.svg";